<div class="step-container registration-success-page">
  <div class="registration-content">
    <h5 class="registration-success-page-title text-primary">
      {{ 'fgbcl.registration.success.page.title' | translate }}
    </h5>
    <p class="registration-success-message">{{ 'registration.success.page.message' | translate }}</p>
    <div class="action-wrapper">
      <button class="btn btn-primary fw-bold" (click)="loginAndRedirect()">
        {{ 'registration.success.page.button' | translate }}
      </button>
    </div>
  </div>
</div>
